import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuListItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ClockIcon from "@mui/icons-material/WatchLater";
import CloseIcon from "@mui/icons-material/Close";

import styles from "./style";

const ExpiryIndicator = ({ licenseExpiresOn = null }) => {
  const [state, setState] = useState({
    isModalOpen: false,
  });
  if (!licenseExpiresOn) {
    return null;
  }

  const expirationDate = new Date(licenseExpiresOn);
  const expiryString =
    expirationDate == "Invalid Date"
      ? licenseExpiresOn
      : `${
          expirationDate.getMonth() + 1
        }/${expirationDate.getDate()}/${expirationDate
          .getFullYear()
          .toString()
          .slice(-2)}`;

  //JSX
  return (
    <>
      <MenuListItem
        sx={styles.expiryWrapper}
        disableRipple
        onClick={(event) => {
          setState((prevState) => ({
            ...prevState,
            isModalOpen: true,
          }));
        }}
      >
        <ListItemText primary={`License Expires: ${expiryString}`} />
        <ListItemIcon sx={styles.icon}>
          <AccessTimeOutlinedIcon fontSize="small" />
        </ListItemIcon>
      </MenuListItem>
      <Dialog
        onClose={() => {
          setState((prevState) => ({
            ...prevState,
            isModalOpen: false,
          }));
        }}
        open={state.isModalOpen}
      >
        <DialogTitle sx={styles.dialogTitle}>
          <Typography variant="h6">Account License</Typography>
          <IconButton
            aria-label="close"
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                isModalOpen: false,
              }))
            }
            sx={styles.closeIcon}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={styles.expiryModal}>
          <Box sx={styles.dialogContent}>
            <ClockIcon color="primary" sx={styles.clockBtn} />
            <Typography variant="caption">
              {`License Expires: ${expiryString}`}
            </Typography>
          </Box>
          <Typography color="textSeondary" variant="body2">
            To renew your license, contact your Account Executive or sales
            representative.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setState((prevState) => ({
                ...prevState,
                isModalOpen: false,
              }));
            }}
            sx={styles.actionBtns}
            variant="contained"
            color="primary"
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ExpiryIndicator;
